import { useQuery } from '@tanstack/react-query';

import { HomepageGeoParams, getHomepageGeoValues } from '~/services/ExperiencesService';

import { experiencesQueryKeys } from './experiencesQueryKeys';

export function useHomepageGeoValues(params: HomepageGeoParams, enabled: boolean) {
  return useQuery({
    queryKey: experiencesQueryKeys.homepageGeoValues(params),
    queryFn: ({ signal }) => getHomepageGeoValues(params, signal),
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
